module.exports = __webpack_public_path__ + "img/mouse2-fill.09aea70a.svg";